/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Starter_DescInputs */

const en_landing_pricing_starter_desc = /** @type {(inputs: Landing_Pricing_Starter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For individuals`)
};

const zh_landing_pricing_starter_desc = /** @type {(inputs: Landing_Pricing_Starter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合个人用户`)
};

/**
* | output |
* | --- |
* | "For individuals" |
*
* @param {Landing_Pricing_Starter_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_starter_desc = /** @type {((inputs?: Landing_Pricing_Starter_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Starter_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_starter_desc(inputs)
	return zh_landing_pricing_starter_desc(inputs)
});
export { landing_pricing_starter_desc as "landing.pricing.starter_desc" }